// Single source of truth for every external destination used across the site.
// Do not alter these URLs — they are the organization's real destinations.

export const externalLinks = {
  getConnectedForm:
    'https://docs.google.com/forms/d/e/1FAIpQLSfeuu9P3ouXzn_Uzg5k8ZzNyGFU2T6E8PNpN8jn8A0DkHW-3g/viewform',
  instagram: 'https://www.instagram.com/ucfbcm/',
  discord: 'https://discord.gg/3eQH4qEese',
  knightConnect:
    'https://knightconnect.campuslabs.com/engage/organization/baptistcollegiateministries',
  /** Current-year album: "2026–27 BCM Photos". */
  photoAlbum:
    'https://drive.google.com/drive/folders/1r3AnZsKyRN_AdIi6LcppwV315l_ITxH6?usp=sharing',
  studentUnion: 'https://www.ucf.edu/location/student-union/',
  email: 'mailto:ucfbcm@ucfbcm.com',
  /** Worship team interest form — separate from the general Get Connected form. */
  worshipTeamForm:
    'https://docs.google.com/forms/d/e/1FAIpQLSfUw9WYqjgQRd7Hsf4qRg5Xg9kvHLmZn5H5_VM-6Mz-6f_Lnw/viewform?usp=header',
  /**
   * Giving destination supplied by BCM leadership. Used exactly as provided.
   * TODO: This PayPal link carries a session-style token that could not be
   * click-verified from the editor. Confirm it resolves, or replace it with a
   * permanent PayPal donation URL / button code before launch.
   */
  paypalDonate:
    'https://www.paypal.com/donate?token=NTZGJdm3U9CqtdcTM13BOaIW1ZEco2AVieGi581bvHZZW9AtMZtgqBFz0EY_gyDuVmMICCjevk53YXlO',
} as const

export const emailAddress = 'ucfbcm@ucfbcm.com'

// The regular worship schedule and location, stated plainly. BCM announces any
// exceptions through its social channels, so the site does not qualify these.
export const meeting = {
  summary: 'Thursdays at 7:30 PM',
  /** Two-line confirmed location, in display order. */
  locationLines: ['Cape Florida Ballroom, Room 316', 'UCF Student Union, 3rd Floor'],
  /** Single-line form for compact spots. */
  location: 'Cape Florida Ballroom, Room 316 • UCF Student Union, 3rd Floor',
} as const

/** The three official student channels, in the order they are always presented. */
export const officialChannels = [
  {
    id: 'instagram',
    title: 'Follow on Instagram',
    copy: 'Event announcements, reminders, photos, and weekly updates',
    href: externalLinks.instagram,
  },
  {
    id: 'knightconnect',
    title: 'View KnightConnect',
    copy: 'Official UCF organization information and posted events',
    href: externalLinks.knightConnect,
  },
  {
    id: 'discord',
    title: 'Join the Discord',
    copy: 'Community conversations and current announcements',
    href: externalLinks.discord,
  },
] as const

export type NavItem = {
  label: string
  to: string
}

export const primaryNav: NavItem[] = [
  { label: 'Home', to: '/' },
  { label: 'Events', to: '/events' },
  { label: 'About', to: '/about' },
  { label: 'Meet the Team', to: '/meet-the-team' },
  { label: 'Photos', to: '/photos' },
  { label: 'Local Churches', to: '/local-churches' },
  { label: 'Give', to: '/give' },
]

export const allRoutes: { label: string; to: string }[] = [
  { label: 'Home', to: '/' },
  { label: 'Events', to: '/events' },
  { label: 'About', to: '/about' },
  { label: 'Meet the Team', to: '/meet-the-team' },
  { label: 'Photos', to: '/photos' },
  { label: 'Local Churches', to: '/local-churches' },
  { label: 'Connect', to: '/connect' },
  { label: 'Give', to: '/give' },
]
